"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("border-top:solid 1px rgba(", theme.color.monochrome.black_rgba, ", 0.5);position:relative;padding:", theme.spacing[10], " ", theme.spacing[5], ";&:before{content:'';position:absolute;left:0;right:0;top:0;border-top:solid 1px ", theme.color.monochrome.dark, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var styles = {
  base: base
};
exports.styles = styles;
//# sourceMappingURL=MenuFooter.styles.js.map